import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import "../config";
import {
  colorTheme,
} from "../Style/ColorTheme/colorTheme";
import Store from "../Store";

const color_Theme = colorTheme();

export const Selector = (props) => {
  const { t } = useTranslation("common");
  const {
    options,
    value,
    _handleSelect,
    disabled,
    isMulti,
    isSearchable,
    placeholder = t("Select_"),
    getOptionLabel,
    getOptionValue,
    isClearable,
    width,
    controlHeight = "38px",
    filterOptionKey = "label",
  } = props;

  const { isBlueOnion } = Store.common;

  const filterOption = (candidate, input) => {
    if (input) {
      return candidate.data[filterOptionKey]
        .toLowerCase()
        .includes(input.toLowerCase());
    }
    return true;
  };

  const customStyles = {
    control: (base, { isFocused }) => ({
      ...base,
      cursor: "pointer",
      border: "1px solid #ccc",
      borderRadius: "4px",
      // width: "210px",
      width: width || "210px", // ✅ 改成動態寬度
      height: controlHeight,
      minHeight: controlHeight,
      maxHeight: controlHeight,
      display: "flex", // 使用 flexbox 來垂直居中
      alignItems: "center", // 垂直居中
      justifyContent: "center",
      boxShadow: "none",
      outline: "none",
      borderColor: "#ccc", // 避免藍邊
      "&:hover": {
        borderColor: "#ccc", // 保持原色
        boxShadow: "none",
        outline: "none",
      },
      ...(isFocused
        ? {
            borderColor: "#ccc",
            boxShadow: "none",
          }
        : {}),
    }),
    input: (base) => ({
      ...base,
      padding: "0", // 去掉 padding
      margin: "0", // 去掉 margin
      lineHeight: "normal",
      fontSize: "14px", // 設定字體大小（可選）
      outline: "none", // ✅ 移除輪廓
      boxShadow: "none", // ✅ 移除發光陰影
      borderColor: "#ccc", // 避免聚焦變藍
      "::selection": {
        background: "transparent", // 🔥 去除藍底
        color: "inherit",
      },
    }),
    singleValue: (base) => ({
      ...base,
      maxWidth: "calc(100% - 24px)", // 給右邊 icon 留空間
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      paddingLeft: "0px", // ✅ 保持左邊距
      paddingRight: "0px", // ✅ 保持右邊距（避免字貼到 icon）
      boxSizing: "border-box", // ✅ 避免溢出寬度
    }),
    menu: (base) => ({
      ...base,
      padding: "0",
      width: width || "210px", // ✅ 改成動態寬度
      // width: "210px", // 設定選單的寬度與選擇框一致
      borderRadius: "4px", // 選單圓角
      marginTop: "4px", // 設定選單的上邊距
      border: "1px solid #ccc", // 設定選單邊框顏色
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // 設定選單的陰影
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0",
      paddingLeft: "10px",
      display: "flex",
      alignItems: "center",
      height: "100%",
      overflow: "hidden", // 防止內容溢出
      outline: "none",
      boxShadow: "none", // ✅ 有些焦點樣式加在這層
    }),

    indicatorsContainer: (base) => ({
      ...base,
      height: "100%",
      alignItems: "center",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 400,
    }),

    menuList: (base) => ({
      ...base,
      maxHeight: "200px", // 設定選項列表的最大高度
      overflowY: "auto", // 選項超出顯示區域時啟用滾動條
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#e0e0e0" : "#fff", // 選項懸停時背景色
      color: state.isSelected ? "#007bff" : "#333", // 設定選中選項顏色
      padding: "10px", // 設定選項的內邊距
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#d5d5d5", // 滑鼠懸停時背景顏色
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#333", // 提示詞顏色與輸入文字一致
      fontSize: "16px", // 提示詞字體大小與輸入文字一致
      fontStyle: "normal", // 提示詞字型與輸入文字一致
      fontWeight: "normal", // 提示詞字體粗度與輸入文字一致
    }),
  };

  const Icon = ({ innerRef, innerProps }) => (
    <span
      className="px-2"
      role="img"
      aria-label="Dropdown emoji"
      ref={innerRef}
      {...innerProps}
    >
      {isBlueOnion === "true" ? (
        <i
          class="bi bi-chevron-down"
          style={{ color: color_Theme.dropDownColor }}
        ></i>
      ) : (
        <i
          className="bi bi-caret-down-fill"
          style={{ color: color_Theme.dropDownColor }}
        />
      )}
    </span>
  );

  const ClearIcon = ({ innerRef, innerProps }) => (
    <span
      className="px-2"
      style={{ fontSize: "1.5rem" }}
      role="img"
      aria-label="Clear selection"
      ref={innerRef}
      {...innerProps}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        _handleSelect("");
      }}
    >
      <i className="bi bi-x" style={{ color: "gray" }} />
    </span>
  );

  const components = {
    DropdownIndicator: Icon,
    ClearIndicator: ClearIcon,
  };

  return (
    <div>
      <Select
        isClearable={isClearable}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        placeholder={placeholder}
        isSearchable={isSearchable}
        value={value || null}
        closeMenuOnSelect={isMulti ? false : true}
        isMulti={isMulti ? true : false}
        styles={customStyles}
        menuPortalTarget={document.body}
        filterOption={filterOption}
        options={options}
        defaultValue={value || null}
        onChange={(e) => _handleSelect(e)}
        isDisabled={disabled}
        components={components}
        isOptionDisabled={(option) => option.isDisabled}
      />
    </div>
  );
};
